<template>
  <span @touchstart="stopProp">
    <span
      v-if="!clear"
      class="cover tag"
      @mousedown="start"
      @touchstart="start"
      :style="{height: `${h}px`, width: `${w - position}px`, left: `${x + position}px`, top: `${y}px`}"
    ></span>
    <span
      v-else
      class="uncover tag"
      @mouseup="cover"
      @touchstart="cover"
      :style="{height: `${h}px`, width: `${w}px`, left: `${x}px`, top: `${y}px`}"
    ></span>
  </span>
</template>

<script>
/* eslint-disable no-console */

export default {
  name: "tag",
  props: {
    id: Number,
    clear: Boolean,
    x: Number,
    y: Number,
    w: Number,
    h: Number,
    zoomRatio: Number
  },
  components: {},
  data() {
    return {
      position: 0,
      dragging: false,
      initPosition: { x: 0, y: 0 },
      time: 0,
      isDragTimer: null
    };
  },
  mounted() {
    window.addEventListener("touchend", this.end, { passive: false });
    window.addEventListener("touchmove", this.move, { passive: false });
    window.addEventListener("mouseup", this.end, { passive: false });
    window.addEventListener("mousemove", this.move, { passive: false });
  },
  beforeDestroy() {
    window.removeEventListener("touchend", this.end);
    window.removeEventListener("touchmove", this.move);
    window.removeEventListener("mouseup", this.end);
    window.removeEventListener("mousemove", this.move);
  },
  computed: {},
  methods: {
    stopProp(e) {
      console.log("stop propagation");
      e.stopPropagation();
    },
    cover(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log("cover" + this.id);
      console.log(Date.now() - this.isDragTimer);
      if (Date.now() - this.isDragTimer > 120) {
        this.$nextTick(() => {
          this.$emit("reset", this.id);
        });
      }
    },
    start(e) {
      console.log("drag start" + this.id);
      console.log(Date.now() - this.isDragTimer);
      e.preventDefault();
      e.stopPropagation();
      if (Date.now() - this.isDragTimer > 120) {
        let point;
        this.isDragTimer = Date.now();
        this.dragging = true;
        if (e.touches) {
          point = e.changedTouches[0];
        } else {
          point = e;
        }

        this.initPosition = { x: point.pageX, y: point.pageY };
      }
    },
    move(e) {
      // console.log(this.dragging);
      if (this.dragging) {
        e.preventDefault();
        e.stopPropagation();
        console.log("dragging" + this.id);
        let point;
        this.dragging = true;
        if (e.touches) {
          point = e.changedTouches[0];
        } else {
          point = e;
        }
        const pos =
          (point.pageX - this.initPosition.x) * (1 / this.zoomRatio) > 0;
        if (pos) {
          this.position =
            (point.pageX - this.initPosition.x) * (1 / this.zoomRatio);
          console.log(point.pageX - this.initPosition.x);
          console.log(this.position);
        }
      }
    },
    end(e) {
      console.log("end" + this.id);
      console.log(this.isDragTimer);
      if (this.isDragTimer) {
        if (this.position === 0 && this.dragging) {
          this.dragging = false;
          this.$emit("clear", this.id);
        }

        if (this.dragging) {
          this.left = e.pageX - this.originalX;
          this.dragging = false;
          if (this.position >= this.w) {
            this.$emit("clear", this.id);
            this.position = 0;
          }
          this.position = 0;
        }
      } else {
        console.log("nothing happend");
      }
      this.isDragTimer = Date.now();
    }
  },
  watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
span.text {
  position: relative;
}
span.cover {
  position: absolute;
  top: 0px;
  background: #aee;
}
span.uncover {
  position: absolute;
  top: 0px;
  background: rgba(0, 0, 0, 0.01);
}

.tag {
  position: absolute;
}
</style>
